import React, {useState} from "react";
import {Menu, MenuItem, Sidebar, SubMenu} from "react-pro-sidebar";
import OpsIcon from "../../ops-library/ops-icon";
import {Images} from "../../constants/Images";
import {SlArrowLeft} from "react-icons/sl";
import {FaChartArea, FaChartBar, FaCompactDisc, FaMusic} from "react-icons/fa";
import {MdLogout, MdOutlineRateReview, MdWeb} from "react-icons/md";
import {LuInfo} from "react-icons/lu";
import {MdManageHistory} from "react-icons/md";
import {TbArticle} from "react-icons/tb";
import {GiRopeway} from "react-icons/gi";
import {FaEuroSign} from "react-icons/fa";
import {FaPeopleGroup} from "react-icons/fa6";
import {FaFileSignature} from "react-icons/fa";
import {FaShoppingCart} from "react-icons/fa";
import {FaCashRegister} from "react-icons/fa";
import {MdManageAccounts} from "react-icons/md";
import {LuSettings2} from "react-icons/lu";
import {TiWeatherPartlySunny} from "react-icons/ti";
import {hasRoleAccess} from "../../functions/hasRoleAccess";
import {useNavigate, useParams} from "react-router-dom";
import {ACCESS_TOKEN_KEY} from "../../constants/constants";
import {IoMusicalNotesSharp} from "react-icons/io5";
import {GoFileDirectory} from "react-icons/go";
import {HiOutlinePhoto} from "react-icons/hi2";

const AdminSidebar = ({user, roles}) => {
    const [collapsed, setCollapsed] = useState(true);
    const {adminSection} = useParams()
    const navigate = useNavigate()

    function handleLogout() {
        localStorage.removeItem(ACCESS_TOKEN_KEY);
        navigate("/");
    }

    return (
        <div className="adm-sidebar">
            <Sidebar collapsed={collapsed}
                     className="bg-g-5"
                     rootStyles={{
                         width: '20rem',
                         paddingTop: '9vh',
                         // height: '83vh',
                         height: '100%',
                         minHeight: '550px',
                     }}
            >
                <Menu
                    menuItemStyles={{
                        button: ({level, active, disabled}) => {
                            // if (level === 0)
                            return {
                                color: disabled ? 'var(--color-g-2)' : 'var(--color-g-1)',
                                backgroundColor: active ? 'var(--color-1)' : 'var(--color-g-5)',
                                fontWeight: active ? 700 : 400,
                            };
                        },
                    }}
                >

                    {(user?.role === 'system-admin' || user?.role === 'admin' || user?.role === 'member') && <>
                        {/*KONCERTY*/}
                        <MenuItem
                            // disabled={!hasRoleAccess(roles.find((section) => section.sectionId === 'koncerty').sectionId, user?.role)}
                            active={adminSection === 'koncerty'}
                            icon={<IoMusicalNotesSharp
                                color={adminSection === 'koncerty' ? 'var(--color-g-1)' : 'var(--color-g-7)'}
                                className="ops-icon-bg"/>}
                            onClick={() => {
                                navigate(`/admin/koncerty`)
                            }}>
                            Koncerty
                        </MenuItem>
                        {/*OBJEDNAVKY*/}
                        <MenuItem
                            active={adminSection === 'objednavky'}
                            icon={<GoFileDirectory
                                color={adminSection === 'objednavky' ? 'var(--color-g-1)' : 'var(--color-g-7)'}
                                className="ops-icon-bg"/>}
                            onClick={() => {
                                navigate(`/admin/objednavky`)
                            }}>
                            Objednávky
                        </MenuItem>
                        {/*PRODUKTY*/}
                        <MenuItem
                            active={adminSection === 'produkty'}
                            icon={<FaCompactDisc
                                color={adminSection === 'produkty' ? 'var(--color-g-1)' : 'var(--color-g-7)'}
                                className="ops-icon-bg"/>}
                            onClick={() => {
                                navigate(`/admin/produkty`)
                            }}>
                            Produkty
                        </MenuItem>
                        {/*AKTUALITY*/}
                        <MenuItem
                            active={adminSection === 'aktuality'}
                            icon={<TbArticle
                                color={adminSection === 'aktuality' ? 'var(--color-g-1)' : 'var(--color-g-7)'}
                                className="ops-icon-bg"/>}
                            onClick={() => {
                                navigate(`/admin/aktuality`)
                            }}>
                            Aktuality
                        </MenuItem>
                        {/*RECENZIE*/}
                        <MenuItem
                            active={adminSection === 'recenzie'}
                            icon={<MdOutlineRateReview
                                color={adminSection === 'recenzie' ? 'var(--color-g-1)' : 'var(--color-g-7)'}
                                className="ops-icon-bg"/>}
                            onClick={() => {
                                navigate(`/admin/recenzie`)
                            }}>
                            Recenzie
                        </MenuItem>
                        {/*GALERIA*/}
                        <MenuItem
                            active={adminSection === 'galeria'}
                            icon={<HiOutlinePhoto
                                color={adminSection === 'galeria' ? 'var(--color-g-1)' : 'var(--color-g-7)'}
                                className="ops-icon-bg"/>}
                            onClick={() => {
                                navigate(`/admin/galeria`)
                            }}>
                            Galéria
                        </MenuItem>
                        {/*INFORMACIE*/}
                        <MenuItem
                            active={adminSection === 'informacie'}
                            icon={<LuInfo
                                color={adminSection === 'informacie' ? 'var(--color-g-1)' : 'var(--color-g-7)'}
                                className="ops-icon-bg"/>}
                            onClick={() => {
                                navigate(`/admin/informacie`)
                            }}>
                            Informácie
                        </MenuItem>
                    </>
                    }

                    {user?.role === 'system-admin' && <>
                        {/*SPRAVA POUZIVATELOV*/}
                        <MenuItem
                            active={adminSection === 'webApp-manazment'}
                            icon={<MdManageAccounts
                                color={adminSection === 'webApp-manazment' ? 'var(--color-g-1)' : 'var(--color-g-7)'}
                                className="ops-icon-bg"/>}
                            // suffix={<OpsIcon source={Images.ICON_NEW}/>}
                            onClick={() => {
                                navigate(`/admin/webApp-manazment`)
                            }}>
                            Správa užívateľov
                        </MenuItem>
                    </>}

                    {/*LOGOUT*/}
                    <MenuItem
                        active={adminSection === 'logout'}
                        icon={<MdLogout
                            color='var(--color-g-7)'
                            className="ops-icon-bg"/>}
                        onClick={() => {
                            handleLogout()
                        }}>
                        Odhlásiť sa
                    </MenuItem>

                </Menu>
            </Sidebar>


            <div className={`adm-sidebar-collapse-btn ${collapsed ? 'justify-content-center' : 'ps-4'}`}
                 onClick={() => setCollapsed(!collapsed)}>
                <SlArrowLeft color='var(--color-g-1)' className={`ops-icon-md ${!collapsed || 'transform-right'}`}/>
            </div>
        </div>
    )
}

export default AdminSidebar;